"use strict";

const boxes = {
    predefined: document.querySelector('.predefined'),
    contactForm: document.querySelector('.box.box-contact-form')
}

for (const box of Object.values(boxes)) {
    if (box) {
        let prev = box.previousElementSibling;

        if (!prev) {
            break;
        }

        if (prev.classList.contains('background-box')) {
            if (prev.classList.contains('joining')) {
                let pre = box;
                box.remove();
                prev.children[0].children[0].children[0].appendChild(pre);
                break;
            }

            prev.childNodes.forEach((ele) => {
                if (ele.classList.contains('joining')) {
                    ele.parentElement.classList.add('merged');
                    ele.appendChild(box);
                }
            });
        }

        if (prev.classList.contains('dynamic-text-box')) {
            if (prev.classList.contains('joining')) {
                let pre = box;
                box.remove();
                prev.classList.add('form');
                prev.appendChild(pre);
                break;
            }
        }
    }
}
